const initialState = {
    fname: '',
    lname: '',
    gender: 'انتخاب کنید',
    isLoading: false,
};
const edit_profile = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_EDIT_PROFILE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default edit_profile;
